import { render } from "./MigrateVMStorage.vue?vue&type=template&id=8672bd40&scoped=true"
import script from "./MigrateVMStorage.vue?vue&type=script&lang=js"
export * from "./MigrateVMStorage.vue?vue&type=script&lang=js"

import "./MigrateVMStorage.vue?vue&type=style&index=0&id=8672bd40&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8672bd40"]])

export default __exports__